var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7578 2.92676L18.2734 1.44238C17.8047 0.973633 17.1406 0.700195 16.5156 0.700195C15.8906 0.700195 15.2266 0.973633 14.7578 1.44238L0.96875 15.2314L0.5 19.6846C0.421875 20.2314 0.851562 20.7002 1.39844 20.7002C1.4375 20.7002 1.47656 20.7002 1.51562 20.7002L5.96875 20.2314L19.7578 6.44238C20.7344 5.46582 20.7344 3.90332 19.7578 2.92676ZM5.42188 19.0205L1.78906 19.4111L2.17969 15.7783L12.4922 5.46582L15.7344 8.70801L5.42188 19.0205ZM18.8594 5.58301L16.5938 7.84863L13.3516 4.60645L15.6172 2.34082C15.8516 2.10645 16.1641 1.9502 16.5156 1.9502C16.8672 1.9502 17.1797 2.10645 17.4141 2.34082L18.8594 3.78613C19.3672 4.29395 19.3672 5.0752 18.8594 5.58301Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.459da1f6.svg";
export { ForwardRef as ReactComponent };